import { render, staticRenderFns } from "./ClientItemCreate.vue?vue&type=template&id=5bae304e"
import script from "./ClientItemCreate.vue?vue&type=script&lang=js"
export * from "./ClientItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports